import { Link, Tooltip } from '@chakra-ui/react'
import numeral from 'numeral'
import { useContext } from 'react'
import { UserContext } from '../../../providers'
import { RoleEnum } from '../../../../utils/roles'

const Usage = (): React.ReactElement | null => {
  const { user } = useContext(UserContext)
  if (user?.roles === RoleEnum.RESTRICTED) {
    return null
  }
  return (
    <>
      <Link
        color="appDarkIndigo"
        fontSize="12px"
        padding="0 10px"
        cursor="default"
        _hover={{
          textDecoration: 'none',
        }}
      >
        Storage:{' '}
        <Tooltip label={`${user?.storageDetails.usage} B used`}>
          {`${numeral(user?.storageDetails.usage)
            .format('0.0 ib')
            .replace('i', '')} used`}
        </Tooltip>
      </Link>
      <Link
        color="appDarkIndigo"
        fontSize="12px"
        padding="0 10px"
        cursor="default"
        _hover={{ textDecoration: 'none' }}
      >
        Total files: {numeral(user?.storageDetails.fileCount).format('0,0')}
      </Link>
    </>
  )
}

export default Usage
